import { render, staticRenderFns } from "./StocksForm.vue?vue&type=template&id=7739ed57&scoped=true&"
import script from "./StocksForm.vue?vue&type=script&lang=js&"
export * from "./StocksForm.vue?vue&type=script&lang=js&"
import style0 from "./StocksForm.vue?vue&type=style&index=0&id=7739ed57&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7739ed57",
  null
  
)

export default component.exports